import { useContext } from 'react';
import { F as FormStateContext } from '../contexts/FormStage/FormStageContext-CEDzLzYf.js';

const useFormStage = () => {
  const {
    stage,
    onIntroVisited
  } = useContext(FormStateContext);
  return {
    stage,
    onIntroVisited
  };
};

export { useFormStage as u };
//# sourceMappingURL=useStage-C5gC2haD.js.map
